import React, { useState } from 'react';
import emailjs from '@emailjs/browser';

const BookingForm = ({ onClose }) => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    guests: 1,
    rooms: 1,
    checkIn: '',
    checkOut: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    try {
      const response = await emailjs.send(
        'service_5b58o8q',
        'template_1jkh7yn', 
        {
          from_name: `${formData.firstName} ${formData.lastName}`,
          from_email: formData.email,
          phone: formData.phone,
          guests: formData.guests,
          rooms: formData.rooms,
          check_in: formData.checkIn,
          check_out: formData.checkOut,
          message: formData.message
        },
        'lV6-QVLOJBI_Bz9Co'
      );
      
      console.log('SUCCESS!', response.status, response.text);
      setSubmitStatus('success');
      setFormData({
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        guests: 1,
        rooms: 1,
        checkIn: '',
        checkOut: '',
        message: ''
      });
    } catch (error) {
      console.error('FAILED...', error);
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };


  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Réserver une chambre</h2>
          <button className="close-button" onClick={onClose}>×</button>
        </div>
        
        {submitStatus === 'success' ? (
          <div className="success-message">
            <h3>Merci pour votre réservation!</h3>
            <p>Nous avons reçu votre demande et vous contacterons sous peu pour confirmation.</p>
            <button className="success-button" onClick={onClose}>Fermer</button>
          </div>
        ) : submitStatus === 'error' ? (
          <div className="error-message">
            <h3>Une erreur s'est produite</h3>
            <p>Veuillez réessayer ou nous contacter directement par téléphone.</p>
            <button className="retry-button" onClick={() => setSubmitStatus(null)}>Réessayer</button>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="booking-form">
            <div className="form-row">
              <div className="input-group">
                <label className="form-label">Prénom *</label>
                <input
                  type="text"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleInputChange}
                  required
                  className="form-input"
                />
              </div>
              <div className="input-group">
                <label className="form-label">Nom *</label>
                <input
                  type="text"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleInputChange}
                  required
                  className="form-input"
                />
              </div>
            </div>
            
            <div className="form-row">
              <div className="input-group">
                <label className="form-label">Email *</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                  className="form-input"
                />
              </div>
              <div className="input-group">
                <label className="form-label">Téléphone</label>
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleInputChange}
                  className="form-input"
                />
              </div>
            </div>
            
            <div className="form-row">
              <div className="input-group">
                <label className="form-label">Nombre de personnes (max 100)</label>
                <input
                  type="number"
                  name="guests"
                  min="1"
                  max="100"
                  value={formData.guests}
                  onChange={handleInputChange}
                  required
                  className="form-input"
                />
              </div>
              <div className="input-group">
                <label className="form-label">Nombre de chambres (max 100)</label>
                <input
                  type="number"
                  name="rooms"
                  min="1"
                  max="100"
                  value={formData.rooms}
                  onChange={handleInputChange}
                  required
                  className="form-input"
                />
              </div>
            </div>
            
            <div className="form-row">
              <div className="input-group">
                <label className="form-label">Date d'arrivée *</label>
                <input
                  type="date"
                  name="checkIn"
                  value={formData.checkIn}
                  onChange={handleInputChange}
                  required
                  className="form-input"
                />
              </div>
              <div className="input-group">
                <label className="form-label">Date de départ *</label>
                <input
                  type="date"
                  name="checkOut"
                  value={formData.checkOut}
                  onChange={handleInputChange}
                  required
                  className="form-input"
                />
              </div>
            </div>
            
            <div className="input-group">
              <label className="form-label">Message supplémentaire</label>
              <textarea
                name="message"
                value={formData.message}
                onChange={handleInputChange}
                className="form-input"
                style={{ minHeight: '80px'}}
              />
            </div>
            
            <button 
              type="submit" 
              disabled={isSubmitting}
              className={isSubmitting ? "submit-button submitting" : "submit-button"}
            >
              {isSubmitting ? 'Envoi en cours...' : 'Réserver'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default BookingForm;